<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Mehinaku</title>
<link href="../styles/stylesheet.css" rel="stylesheet" type="text/css"/>
<h2 class="head02" id="fm_1"><a id="page_ix"></a><a href="#/xhtml/Contents#fm1">Figures</a></h2>
<p class="hang" id="f1"><a href="#/xhtml/Chapter2#fig_1">  1. Map of Brazil showing the location of the Mehinaku village</a></p>
<p class="hang" id="f2"><a href="#/xhtml/Chapter2#fig_2">  2. Xingu topography</a></p>
<p class="hang" id="f3"><a href="#/xhtml/Chapter2#fig_3">  3. The fascination of the outside world</a></p>
<p class="hang" id="f4"><a href="#/xhtml/Chapter2#fig_4">  4. A Mehinaku view of everyday village life</a></p>
<p class="hang" id="f5"><a href="#/xhtml/Chapter3#fig_5">  5. A heliocentric cosmology</a></p>
<p class="hang" id="f6"><a href="#/xhtml/Chapter3#fig_6">  6. Akanai’s map of the known world</a></p>
<p class="hang" id="f7"><a href="#/xhtml/Chapter3#fig_7">  7. Aerial view of Mehinaku village</a></p>
<p class="hang" id="f8"><a href="#/xhtml/Chapter3#fig_8">  8. The Mehinaku village, January 1972</a></p>
<p class="hang" id="f9"><a href="#/xhtml/Chapter3#fig_9">  9. Three views of the Mehinaku village</a></p>
<p class="hang" id="f10"><a href="#/xhtml/Chapter3#fig_10">10. The true house</a></p>
<p class="hang" id="f11"><span href="#/xhtml/Chapter4#fig_11" title="Link target outside of Sample">11. A mother grooms her daughter</span></p>
<p class="hang" id="f12"><span href="#/xhtml/Chapter4#fig_12" title="Link target outside of Sample">12. The chief’s foot</span></p>
<p class="hang" id="f13"><span href="#/xhtml/Chapter6#fig_13" title="Link target outside of Sample">13. Come and drink <i>nukaiya</i>!</span></p>
<p class="hang" id="f14"><span href="#/xhtml/Chapter7#fig_14" title="Link target outside of Sample">14. Playing outside the village</span></p>
<p class="hang" id="f15"><span href="#/xhtml/Chapter9#fig_15" title="Link target outside of Sample">15. Alligatoring</span></p>
<p class="hang" id="f16"><span href="#/xhtml/Chapter10#fig_16" title="Link target outside of Sample">16. Dressing in front of the men’s house</span></p>
<p class="hang" id="f17"><span href="#/xhtml/Chapter10#fig_17" title="Link target outside of Sample">17. Examples of hair designs</span></p>
<p class="hang" id="f18"><span href="#/xhtml/Chapter10#fig_18" title="Link target outside of Sample">18. Women’s adornment</span></p>
<p class="hang" id="f19"><span href="#/xhtml/Chapter14#fig_19" title="Link target outside of Sample">19. Amairi in seclusion</span></p>
<p class="hang" id="f20"><span href="#/xhtml/Chapter14#fig_20" title="Link target outside of Sample">20. Variations in seclusion partitions</span></p>
<p class="hang" id="f21"><span href="#/xhtml/Chapter16#fig_21" title="Link target outside of Sample">21. Residence and kinship</span></p>
<p class="hang" id="f22"><span href="#/xhtml/Chapter16#fig_22" title="Link target outside of Sample">22. Mehinaku consanguineal kinship terminology, simplified</span></p>
<p class="hang" id="f23"><span href="#/xhtml/Chapter16#fig_23" title="Link target outside of Sample">23. Joking with a cross-cousin</span></p>
<p class="hang" id="f24"><span href="#/xhtml/Chapter17#fig_24" title="Link target outside of Sample">24. Kinds of fathers-in-law</span></p>
<p class="hang" id="f25"><span href="#/xhtml/Chapter18#fig_25" title="Link target outside of Sample">25. A monkey</span></p>
<p class="hang" id="f26"><span href="#/xhtml/Chapter18#fig_26" title="Link target outside of Sample">26. A wild Indian</span></p>
<p class="hang" id="f27"><a id="page_x"></a><span href="#/xhtml/Chapter19#fig_27" title="Link target outside of Sample">27. The dance of the Kaiyapa demon</span></p>
<p class="hang" id="f28"><span href="#/xhtml/Chapter20#fig_28" title="Link target outside of Sample">28. Shamanism</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Frontmatter01.vue?6b509f53